export default {
  props: {
    body: {
      type: String,
      required: true,
    },
    footer: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      cardConfig: {
        cardType: 'testimonials',
        background: {
          class: '',
        },
        main: {
          class: '',
        },
        article: {
          class: '',
        },
        header: {
          class: '',
        },
        body: {
          class: '',
        },
        footer: {
          class: '',
        },
      },
    }
  },
}
